"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComponentCreatedContextPayload = void 0;
function createComponentCreatedContextPayload(fromPayload) {
    return {
        content_type: fromPayload.content_type,
        content: fromPayload.content,
        created_at: fromPayload.created_at,
        deleted: false,
        uuid: fromPayload.uuid,
    };
}
exports.createComponentCreatedContextPayload = createComponentCreatedContextPayload;
